import { render, staticRenderFns } from "./CustomLabelMandatory.vue?vue&type=template&id=ab0854b8&scoped=true&"
import script from "./CustomLabelMandatory.vue?vue&type=script&lang=js&"
export * from "./CustomLabelMandatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0854b8",
  null
  
)

export default component.exports